(function() {
  'use strict';
  function syncStickyPrices() {}
  function formatMoney(cents, stripDecimals) {
    const amount = cents / 100;
    const value = stripDecimals ? Math.round(amount) : amount;
    const formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: stripDecimals ? 0 : 2,
      maximumFractionDigits: stripDecimals ? 0 : 2
    });
    return 'Rs.' + formatted;
  }

  function updateProductPrice(el, variant, stripDecimals) {
    const useStrip = stripDecimals !== false;
    if (el.classList.contains('product-zero__price') || el.closest('.product-zero__price')) {
      let current = el.querySelector('.product-zero__price-current');
      let compare = el.querySelector('.product-zero__price-compare');
      if (!current) {
        el.innerHTML = '<span class="product-zero__price-current"></span>';
        current = el.querySelector('.product-zero__price-current');
      }
      if (variant.available) {
        current.textContent = formatMoney(variant.price, useStrip);
      } else {
        current.textContent = 'Sold out';
      }
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!compare) {
          current.insertAdjacentHTML('afterend', '<s class="product-zero__price-compare"></s>');
          compare = el.querySelector('.product-zero__price-compare');
        }
        compare.textContent = formatMoney(variant.compare_at_price, useStrip);
        compare.style.display = '';
      } else if (compare) {
        compare.style.display = 'none';
      }
      syncStickyPrices(variant, useStrip);
      return;
    }

    let html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discount = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      html += '<s class="price__compare-at">' + formatMoney(variant.compare_at_price, useStrip) + '</s>';
      html += '<span class="price__badge">' + discount + '% OFF</span>';
    }
    if (variant.available) {
      html += '<span class="price__current">' + formatMoney(variant.price, useStrip) + '</span>';
    } else {
      html += '<span class="price__current">Sold out</span>';
    }
    el.innerHTML = html;

    syncStickyPrices(variant, useStrip);
  }

  function findCardVariant(product, position, value) {
    const candidates = product.variants.filter(function (v) {
      return v['option' + position] === value;
    });
    return candidates.find(function (v) { return v.available; }) || candidates[0];
  }

  function initProductCards() {
    document.querySelectorAll('[data-product-card]').forEach(function (card) {
      const jsonEl = card.querySelector('[data-product-card-json]');
      if (!jsonEl) return;

      let product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      const optionPosition = parseInt(card.dataset.optionPosition, 10);
      if (!optionPosition) return;

      const form = card.querySelector('.product-card__form');
      const priceEl = card.querySelector('.product-card__price');
      const primaryImage = card.querySelector('.product-card__image--primary');
      const discountEl = card.querySelector('[data-product-card-discount]');
      const saveBadgeEl = card.querySelector('[data-product-card-save-badge]');
      const buyBtn = card.querySelector('[data-product-card-buy]');

      function applyVariant(variant) {
        if (!variant) return;

        if (form) form.querySelector('[name="id"]').value = variant.id;
        if (priceEl) updateProductPrice(priceEl, variant, true);

        if (primaryImage && variant.featured_image) {
          primaryImage.classList.add('is-swapping');
          window.setTimeout(function () {
            primaryImage.src = variant.featured_image.src;
            primaryImage.srcset = '';
            primaryImage.classList.remove('is-swapping');
          }, 120);
        }

        if (discountEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const discount = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            discountEl.textContent = discount + '% OFF';
            discountEl.hidden = false;
            card.classList.add('product-card--sale');
            if (saveBadgeEl) {
              saveBadgeEl.hidden = false;
              saveBadgeEl.textContent = 'SAVE ' + discount + '%';
            }
          } else {
            discountEl.hidden = true;
            card.classList.remove('product-card--sale');
            if (saveBadgeEl) saveBadgeEl.hidden = true;
          }
        }

        if (buyBtn) buyBtn.disabled = !variant.available;
      }

      card.querySelectorAll('[data-card-variant-option]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          card.querySelectorAll('[data-card-variant-option]').forEach(function (optionBtn) {
            optionBtn.classList.remove('is-selected');
            optionBtn.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');

          applyVariant(findCardVariant(product, optionPosition, btn.dataset.cardVariantOption));
        });
      });

      const expandBtn = card.querySelector('[data-expand-variants]');
      if (expandBtn) {
        expandBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const variantsEl = expandBtn.closest('.product-card__variants');
          if (!variantsEl) return;

          variantsEl.classList.add('is-expanded');
          expandBtn.classList.add('is-hidden');
          expandBtn.setAttribute('hidden', '');
          expandBtn.setAttribute('aria-expanded', 'true');
        });
      }
    });
  }

  /* ---- Sub-collection carousels ---- */
  function initSubcollectionCarousels() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-subcollection-carousel]').forEach(function (carousel) {
      if (carousel.dataset.carouselInit === 'true') return;
      carousel.dataset.carouselInit = 'true';

      var track = carousel.querySelector('[data-subcollection-track]');
      var prev = carousel.querySelector('[data-subcollection-prev]');
      var next = carousel.querySelector('[data-subcollection-next]');
      var controls = carousel.querySelector('.collection-zero__subcollection-controls');
      if (!track || !track.children.length) return;

      var slides = track.children;
      var index = 0;
      var autoplayMs = (parseInt(carousel.dataset.autoplaySpeed, 10) || 4) * 1000;
      var autoplayEnabled = carousel.dataset.autoplay !== 'false' && !reducedMotion;
      var timer = null;

      function getSlidesPerView() {
        var configured = parseFloat(carousel.dataset.slidesPerView);
        if (!isNaN(configured) && configured > 0) {
          if (window.innerWidth >= 990) return configured;
        }
        if (window.innerWidth >= 990) return parseFloat(getComputedStyle(carousel).getPropertyValue('--subcollection-columns')) || 4;
        if (window.innerWidth >= 750) return 3;
        return 2;
      }

      function getSlideStep() {
        var slide = slides[0];
        var gap = parseFloat(getComputedStyle(track).gap) || 8;
        return slide.offsetWidth + gap;
      }

      function getMaxIndex() {
        return Math.max(0, slides.length - Math.floor(getSlidesPerView()));
      }

      function updateControlsVisibility() {
        if (!controls) return;
        controls.hidden = getMaxIndex() === 0;
      }

      function updatePosition(animate) {
        var maxIndex = getMaxIndex();
        if (index > maxIndex) index = maxIndex;
        if (index < 0) index = 0;
        track.style.transition = animate === false ? 'none' : 'transform 0.45s ease';
        track.style.transform = 'translateX(-' + (index * getSlideStep()) + 'px)';
        if (prev) prev.disabled = getMaxIndex() === 0;
        if (next) next.disabled = getMaxIndex() === 0;
        updateControlsVisibility();
      }

      function goNext() {
        var maxIndex = getMaxIndex();
        index = index >= maxIndex ? 0 : index + 1;
        updatePosition();
      }

      function goPrev() {
        var maxIndex = getMaxIndex();
        index = index <= 0 ? maxIndex : index - 1;
        updatePosition();
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplayEnabled || getMaxIndex() === 0) return;
        timer = setInterval(goNext, autoplayMs);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          stopAutoplay();
          goPrev();
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          stopAutoplay();
          goNext();
          startAutoplay();
        });
      }

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
      carousel.addEventListener('touchend', function () {
        startAutoplay();
      }, { passive: true });

      window.addEventListener('resize', function () {
        updatePosition(false);
      });

      updatePosition(false);
      startAutoplay();
    });
  }

  /* ---- Product grid carousels (mobile) ---- */
  function initProductGridCarousels() {
    document.querySelectorAll('.product-grid--carousel').forEach(function (track) {
      if (track.dataset.gridSnapInit) return;
      track.dataset.gridSnapInit = 'true';

      function getCards() {
        return Array.from(track.children).filter(function (el) {
          return el.matches('.product-card--zero, .product-card');
        });
      }

      function snapToNearest() {
        const cards = getCards();
        if (cards.length < 2) return;

        const scrollLeft = track.scrollLeft;
        let nearestIndex = 0;
        let minDistance = Infinity;

        cards.forEach(function (card, index) {
          const distance = Math.abs(card.offsetLeft - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            nearestIndex = index;
          }
        });

        const target = cards[nearestIndex].offsetLeft;
        if (Math.abs(scrollLeft - target) > 1) {
          track.scrollTo({ left: target, behavior: 'smooth' });
        }
      }

      track.addEventListener('scroll', function () {
        clearTimeout(track._snapTimer);
        track._snapTimer = setTimeout(snapToNearest, 120);
      }, { passive: true });

      track.addEventListener('touchend', function () {
        setTimeout(snapToNearest, 60);
      }, { passive: true });
    });
  }

  /* ---- Lifestyle tabs ---- */
  function initLifestyleTabs() {
    document.querySelectorAll('[data-lifestyle-tabs]').forEach(function (container) {
      const tabs = container.querySelectorAll('[data-tab-trigger]');
      const panels = container.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const target = tab.dataset.tabTrigger;
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          const panel = container.querySelector('[data-tab-panel="' + target + '"]');
          if (panel) {
            panel.classList.add('is-active');
            panel.removeAttribute('hidden');
          }
        });
      });
    });
  }

  /* ---- Collection filters (apply on button click) ---- */
  function initCollectionFilterApply() {
    const panel = document.querySelector('[data-collection-filters-panel]');
    const grid = document.querySelector('.collection-zero__product-grid');
    if (!panel || !grid) return;

    const applyBtn = panel.querySelector('[data-collection-filters-apply]');
    const clearWrap = panel.querySelector('[data-collection-filter-clear-wrap]');
    const clearBtn = panel.querySelector('[data-collection-filter-clear]');
    const countEl = document.querySelector('[data-collection-product-count]');
    const minPriceInput = panel.querySelector('[data-filter-price-min]');
    const maxPriceInput = panel.querySelector('[data-filter-price-max]');
    const pendingButtons = panel.querySelectorAll('[data-pending-filter]');
    const cards = Array.from(grid.querySelectorAll('[data-product-card]'));

    function getCardData() {
      return Array.from(grid.querySelectorAll('[data-product-card]')).map(function (card) {
        const jsonEl = card.querySelector('[data-product-card-json]');
        let product = null;
        if (jsonEl) {
          try {
            product = JSON.parse(jsonEl.textContent);
          } catch (e) {
            product = null;
          }
        }
        return { card: card, product: product };
      });
    }

    let cardData = getCardData();

    let emptyState = grid.parentElement.querySelector('[data-collection-filter-empty]');
    let appliedState = null;

    function emptyStateTemplate() {
      return { variants: {}, availability: [], price: { min: null, max: null } };
    }

    function getProductOptionValues(product) {
      const result = {};
      if (!product || !product.options || !product.variants) return result;

      product.options.forEach(function (name) {
        const key = name.toLowerCase();
        if (key !== 'title') result[key] = new Set();
      });

      product.variants.forEach(function (variant) {
        [variant.option1, variant.option2, variant.option3].forEach(function (val, index) {
          if (!val || !product.options[index]) return;
          const key = product.options[index].toLowerCase();
          if (key === 'title') return;
          if (!result[key]) result[key] = new Set();
          result[key].add(val);
        });
      });

      const output = {};
      Object.keys(result).forEach(function (key) {
        output[key] = Array.from(result[key]);
      });
      return output;
    }

    function getProductPriceRange(product) {
      if (!product) return { min: 0, max: 0 };
      if (product.price_min != null && product.price_max != null) {
        return { min: product.price_min / 100, max: product.price_max / 100 };
      }
      const prices = (product.variants || []).map(function (variant) {
        return variant.price / 100;
      });
      if (!prices.length) return { min: 0, max: 0 };
      return { min: Math.min.apply(null, prices), max: Math.max.apply(null, prices) };
    }

    function readPendingFromUI() {
      const state = emptyStateTemplate();

      pendingButtons.forEach(function (btn) {
        if (!btn.classList.contains('is-selected')) return;

        const kind = btn.dataset.filterKind;
        const value = btn.dataset.filterValue;
        if (!value) return;

        if (kind === 'variant') {
          const key = (btn.dataset.filterKey || '').toLowerCase();
          if (!key) return;
          if (!state.variants[key]) state.variants[key] = [];
          if (state.variants[key].indexOf(value) === -1) state.variants[key].push(value);
        } else if (kind === 'availability') {
          if (state.availability.indexOf(value) === -1) state.availability.push(value);
        }
      });

      if (minPriceInput && minPriceInput.value !== '') {
        state.price.min = parseFloat(minPriceInput.value);
      }
      if (maxPriceInput && maxPriceInput.value !== '') {
        state.price.max = parseFloat(maxPriceInput.value);
      }

      return state;
    }

    function syncUIFromState(state) {
      pendingButtons.forEach(function (btn) {
        const kind = btn.dataset.filterKind;
        const value = btn.dataset.filterValue;
        let isSelected = false;

        if (kind === 'variant') {
          const key = (btn.dataset.filterKey || '').toLowerCase();
          isSelected = !!(state.variants[key] && state.variants[key].some(function (v) {
            return v.toLowerCase() === value.toLowerCase();
          }));
        } else if (kind === 'availability') {
          isSelected = state.availability.indexOf(value) !== -1;
        }

        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      if (minPriceInput) minPriceInput.value = state.price.min != null ? state.price.min : '';
      if (maxPriceInput) maxPriceInput.value = state.price.max != null ? state.price.max : '';
    }

    function parseStateFromUrl() {
      const state = emptyStateTemplate();
      const params = new URLSearchParams(window.location.search);

      params.forEach(function (value, key) {
        if (key.indexOf('filter.v.option.') === 0) {
          const optionKey = key.slice('filter.v.option.'.length).toLowerCase();
          if (!state.variants[optionKey]) state.variants[optionKey] = [];
          if (state.variants[optionKey].indexOf(value) === -1) state.variants[optionKey].push(value);
        } else if (key === 'filter.v.availability') {
          if (state.availability.indexOf(value) === -1) state.availability.push(value);
        } else if (minPriceInput && key === minPriceInput.name) {
          state.price.min = parseFloat(value);
        } else if (maxPriceInput && key === maxPriceInput.name) {
          state.price.max = parseFloat(value);
        }
      });

      return state;
    }

    function buildUrl(state) {
      const params = new URLSearchParams(window.location.search);

      Array.from(params.keys()).forEach(function (key) {
        if (key.indexOf('filter.v.option.') === 0 || key === 'filter.v.availability') {
          params.delete(key);
        }
        if (minPriceInput && key === minPriceInput.name) params.delete(key);
        if (maxPriceInput && key === maxPriceInput.name) params.delete(key);
      });

      Object.keys(state.variants).forEach(function (optionKey) {
        state.variants[optionKey].forEach(function (value) {
          params.append('filter.v.option.' + optionKey, value);
        });
      });

      state.availability.forEach(function (value) {
        params.append('filter.v.availability', value);
      });

      if (state.price.min != null && !isNaN(state.price.min) && minPriceInput && minPriceInput.name) {
        params.append(minPriceInput.name, String(state.price.min));
      }
      if (state.price.max != null && !isNaN(state.price.max) && maxPriceInput && maxPriceInput.name) {
        params.append(maxPriceInput.name, String(state.price.max));
      }

      const query = params.toString();
      return window.location.pathname + (query ? '?' + query : '');
    }

    function stateHasFilters(state) {
      const hasVariants = Object.keys(state.variants).some(function (key) {
        return state.variants[key].length > 0;
      });
      return hasVariants || state.availability.length > 0 || state.price.min != null || state.price.max != null;
    }

    function productMatches(product, state) {
      if (!stateHasFilters(state)) return true;
      if (!product) return false;

      const variantKeys = Object.keys(state.variants).filter(function (key) {
        return state.variants[key].length > 0;
      });

      for (let i = 0; i < variantKeys.length; i += 1) {
        const optionKey = variantKeys[i];
        const selected = state.variants[optionKey];
        const available = getProductOptionValues(product)[optionKey] || [];
        const matchesOption = selected.some(function (value) {
          return available.some(function (productValue) {
            return productValue.toLowerCase() === value.toLowerCase();
          });
        });
        if (!matchesOption) return false;
      }

      if (state.availability.length > 0) {
        const wantsInStock = state.availability.indexOf('1') !== -1;
        const wantsOutStock = state.availability.indexOf('0') !== -1;
        if (wantsInStock && !wantsOutStock && !product.available) return false;
        if (wantsOutStock && !wantsInStock && product.available) return false;
      }

      if (state.price.min != null || state.price.max != null) {
        const range = getProductPriceRange(product);
        if (state.price.min != null && range.max < state.price.min) return false;
        if (state.price.max != null && range.min > state.price.max) return false;
      }

      return true;
    }

    function renderGrid(state, updateHistory) {
      cardData = getCardData();
      let visibleCount = 0;

      cardData.forEach(function (entry) {
        const show = productMatches(entry.product, state);
        entry.card.classList.toggle('is-filter-hidden', !show);
        if (show) visibleCount += 1;
      });

      const hasActive = stateHasFilters(state);
      if (clearWrap) clearWrap.hidden = !hasActive;

      if (countEl) {
        if (hasActive) {
          countEl.textContent = visibleCount + (visibleCount === 1 ? ' product' : ' products');
        } else if (countEl.dataset.defaultCount) {
          countEl.textContent = countEl.dataset.defaultCount;
        }
      }

      if (visibleCount === 0 && hasActive) {
        if (!emptyState) {
          emptyState = document.createElement('div');
          emptyState.className = 'collection-zero__filter-empty';
          emptyState.dataset.collectionFilterEmpty = '';
          emptyState.textContent = 'No products match your filters.';
          grid.insertAdjacentElement('afterend', emptyState);
        }
        emptyState.hidden = false;
      } else if (emptyState) {
        emptyState.hidden = true;
      }

      if (updateHistory) {
        const nextUrl = buildUrl(state);
        if (nextUrl !== window.location.pathname + window.location.search) {
          window.history.pushState({ collectionFilters: true }, '', nextUrl);
        }
      }
    }

    function applyCurrentSelection() {
      appliedState = readPendingFromUI();
      renderGrid(appliedState, true);
    }

    function resetFilters() {
      appliedState = emptyStateTemplate();
      syncUIFromState(appliedState);
      renderGrid(appliedState, true);
    }

    if (countEl && !countEl.dataset.defaultCount) {
      countEl.dataset.defaultCount = countEl.textContent;
    }

    appliedState = parseStateFromUrl();

    if (minPriceInput && minPriceInput.value !== '' && appliedState.price.min == null) {
      appliedState.price.min = parseFloat(minPriceInput.value);
    }
    if (maxPriceInput && maxPriceInput.value !== '' && appliedState.price.max == null) {
      appliedState.price.max = parseFloat(maxPriceInput.value);
    }

    syncUIFromState(appliedState);
    renderGrid(appliedState, false);

    pendingButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        const isSelected = btn.classList.toggle('is-selected');
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        applyCurrentSelection();
        const drawerPanel = document.querySelector('[data-collection-filters]');
        if (drawerPanel && drawerPanel.classList.contains('is-open') && window.innerWidth < 990) {
          drawerPanel.classList.remove('is-open');
          document.body.style.overflow = '';
          const overlay = document.querySelector('[data-collection-filter-overlay]');
          if (overlay) {
            overlay.classList.remove('is-visible');
            overlay.hidden = true;
          }
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', resetFilters);
    }

    window.addEventListener('popstate', function () {
      appliedState = parseStateFromUrl();
      syncUIFromState(appliedState);
      renderGrid(appliedState, false);
    });

    document.addEventListener('zero:collection-products-appended', function () {
      if (appliedState) renderGrid(appliedState, false);
    });
  }

  /* ---- Collection infinite scroll ---- */
  function initCollectionInfiniteScroll() {
    document.querySelectorAll('[data-collection-infinite]').forEach(function (root) {
      if (root.dataset.infiniteBound === '1') return;
      root.dataset.infiniteBound = '1';

      var sectionId = root.dataset.sectionId;
      var grid = document.querySelector('[data-collection-product-grid]') || document.querySelector('.collection-zero__product-grid');
      var sentinel = root.querySelector('[data-collection-infinite-sentinel]');
      var loading = root.querySelector('[data-collection-infinite-loading]');
      if (!grid || !sentinel || !sectionId) return;

      var isLoading = false;

      function getNextUrl() {
        return sentinel.dataset.nextUrl || '';
      }

      function showEndMessage() {
        var end = root.querySelector('[data-collection-infinite-end]');
        if (!end) {
          var completeTitle = root.dataset.completeTitle || "You're all caught up";
          var completeSubtitle = root.dataset.completeSubtitle || "You've explored every piece in this collection.";
          end = document.createElement('div');
          end.className = 'collection-zero__infinite-complete';
          end.dataset.collectionInfiniteEnd = '';
          end.innerHTML =
            '<div class="collection-zero__infinite-complete-card">' +
              '<span class="collection-zero__infinite-complete-icon" aria-hidden="true">✨</span>' +
              '<p class="collection-zero__infinite-complete-title"></p>' +
              '<p class="collection-zero__infinite-complete-sub"></p>' +
            '</div>';
          end.querySelector('.collection-zero__infinite-complete-title').textContent = completeTitle;
          end.querySelector('.collection-zero__infinite-complete-sub').textContent = completeSubtitle;
          root.appendChild(end);
        }
        end.hidden = false;
      }

      function setNextUrl(url) {
        if (url) {
          sentinel.dataset.nextUrl = url;
          sentinel.hidden = false;
        } else {
          delete sentinel.dataset.nextUrl;
          sentinel.hidden = true;
          showEndMessage();
        }
      }

      function loadMore() {
        var nextUrl = getNextUrl();
        if (!nextUrl || isLoading) return;

        isLoading = true;
        if (loading) loading.hidden = false;

        var fetchUrl = new URL(nextUrl, window.location.origin);
        fetchUrl.searchParams.set('section_id', sectionId);

        fetch(fetchUrl.toString())
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to load products');
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-collection-product-grid]') || doc.querySelector('.collection-zero__product-grid');
            if (newGrid) {
              newGrid.querySelectorAll('[data-product-card]').forEach(function (card) {
                grid.appendChild(card);
              });
            }

            var newInfinite = doc.querySelector('[data-collection-infinite]');
            var newSentinel = newInfinite && newInfinite.querySelector('[data-collection-infinite-sentinel]');
            setNextUrl(newSentinel ? newSentinel.dataset.nextUrl : '');

            document.dispatchEvent(new CustomEvent('zero:reinit-product-cards'));
            document.dispatchEvent(new CustomEvent('zero:collection-products-appended'));
          })
          .catch(function () {
            /* keep sentinel so user can scroll again to retry */
          })
          .finally(function () {
            isLoading = false;
            if (loading) loading.hidden = true;
          });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadMore();
          });
        }, { rootMargin: '320px 0px 320px 0px', threshold: 0 });

        observer.observe(sentinel);
      } else if (loading) {
        loading.outerHTML =
          '<button type="button" class="collection-zero__infinite-load-more" data-collection-infinite-load-more>' +
          'Discover more from the hijabeez' +
          '</button>';
        var loadMoreBtn = root.querySelector('[data-collection-infinite-load-more]');
        if (loadMoreBtn) loadMoreBtn.addEventListener('click', loadMore);
      }
    });
  }

  /* ---- Collection filter drawer ---- */
  function initCollectionFilters() {
    const openBtn = document.querySelector('[data-collection-filter-open]');
    const panel = document.querySelector('[data-collection-filters]');
    const overlay = document.querySelector('[data-collection-filter-overlay]');
    const closeBtn = document.querySelector('[data-collection-filter-close]');

    if (!panel) return;

    function openFilters() {
      panel.classList.add('is-open');
      if (overlay) {
        overlay.hidden = false;
        requestAnimationFrame(function () {
          overlay.classList.add('is-visible');
        });
      }
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      panel.classList.remove('is-open');
      if (overlay) {
        overlay.classList.remove('is-visible');
        overlay.addEventListener('transitionend', function handler() {
          overlay.hidden = true;
          overlay.removeEventListener('transitionend', handler);
        }, { once: true });
      }
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);
  }

  function initCollectionAzadiCountdown() {
    function pad(value) {
      return String(value).padStart(2, '0');
    }

    document.querySelectorAll('[data-collection-azadi-banner]').forEach(function(banner) {
      if (banner.dataset.azadiCountdownBound) return;
      banner.dataset.azadiCountdownBound = '1';

      var clock = banner.querySelector('[data-countdown-display][data-countdown-date]');
      if (!clock) return;

      function update() {
        var end = new Date(clock.dataset.countdownDate).getTime();
        if (isNaN(end)) return;

        var diff = Math.max(0, end - Date.now());
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        var daysEl = clock.querySelector('[data-unit="days"]');
        var hoursEl = clock.querySelector('[data-unit="hours"]');
        var minutesEl = clock.querySelector('[data-unit="minutes"]');
        var secondsEl = clock.querySelector('[data-unit="seconds"]');

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      update();
      setInterval(update, 1000);
    });
  }

  function initSeoReadMore() {
    document.querySelectorAll('[data-seo-read-more]').forEach(function(btn) {
      if (btn.dataset.seoReadMoreBound) return;
      btn.dataset.seoReadMoreBound = '1';
      btn.addEventListener('click', function() {
        var content = btn.parentElement.querySelector('[data-seo-read-more-content]');
        if (!content) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var readMore = btn.dataset.readMoreLabel || 'Read More';
        var readLess = btn.dataset.readLessLabel || 'Read Less';
        content.classList.toggle('is-collapsed', expanded);
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        btn.textContent = expanded ? readMore : readLess;
      });
    });
  }

  function initZeroTheme() {
    initLifestyleTabs();
    initProductCards();
    initSubcollectionCarousels();
    initProductGridCarousels();
    initCollectionFilters();
    initCollectionFilterApply();
    initCollectionInfiniteScroll();
    initSeoReadMore();
    initCollectionAzadiCountdown();
  }

  document.addEventListener('DOMContentLoaded', initZeroTheme);
  document.addEventListener('shopify:section:load', function() { initZeroTheme(); });
  document.addEventListener('zero:reinit-product-cards', function() {
    initProductCards();
    initProductGridCarousels();
  });

  window.zeroTheme = window.zeroTheme || {};
  window.zeroTheme.initProductCards = initProductCards;
  window.zeroTheme.initProductGridCarousels = initProductGridCarousels;
})();
